import { render, staticRenderFns } from "./LanguageScores.vue?vue&type=template&id=7bf15c3c&scoped=true"
import script from "./LanguageScores.vue?vue&type=script&lang=js"
export * from "./LanguageScores.vue?vue&type=script&lang=js"
import style0 from "./LanguageScores.vue?vue&type=style&index=0&id=7bf15c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf15c3c",
  null
  
)

export default component.exports